"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = {
  handle: 'prepostfix',
  label: 'Prefix/Postfix',
  initialSettings: {
    prefix: '',
    postfix: ''
  },
  SettingsComponent: function SettingsComponent() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "prefix",
      component: _cccisdFormik.CccisdInput,
      label: "Prefix"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      name: "postfix",
      component: _cccisdFormik.CccisdInput,
      label: "Postfix"
    })));
  },
  getColumnSettings: function getColumnSettings(settings) {
    return {
      render: function render(_ref) {
        var value = _ref.value,
          row = _ref.row;
        var prefix = settings.prefix,
          postfix = settings.postfix;
        return "".concat(prefix).concat(value || value === 0 ? value : '').concat(postfix);
      }
    };
  }
};